angular.module('impactx.formutil').directive('ixOnEnter', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('keyup', function (event) {
                if (event.keyCode == 13) {
                    var callback = $parse(attrs.ixOnEnter)(scope);
                    if (callback) {
                        callback();
                    }
                }
            });
        }
    }
});